<template>
    <div class="flex flex-column align-items-center ribbon-button text-center px-2" v-bind="$attrs" v-on="$listeners">
        <div class="rounded-square-button ribbon-button-icon text-white">
            <i :class="icon"></i>
        </div>
        <div class="mt-2 text-center text-white">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            required: false,
            default: 'fa fa-plus',
        },
    },
    data: () => ({
        //
    }),
    methods: {
        //
    },
}
</script>
<style scoped>
.ribbon-button {
    cursor: pointer;
    border: 1px solid purple;
    border-top: 0;
    border-bottom: 0;
    /* border-radius: 8px; */
    background-color: #480350;
}
</style>
